const actions = {
  LOGIN_BEGIN: 'LOGIN_BEGIN',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_ERR: 'LOGIN_ERR',

  LOGOUT_BEGIN: 'LOGOUT_BEGIN',
  LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
  LOGOUT_ERR: 'LOGOUT_ERR',

  LOGGED_CHECK_BEGIN: 'LOGGED_CHECK_BEGIN',
  LOGGED_CHECK_SUCCESS: 'LOGGED_CHECK_SUCCESS',
  LOGGED_CHECK_ERR: 'LOGGED_CHECK_ERR',

  REGISTER_BEGIN: 'REGISTER_BEGIN',
  REGISTER_SUCCESS: 'REGISTER_SUCCESS',
  REGISTER_ERR: 'REGISTER_ERR',

  registerBegin: () => {
    return {
      type: actions.REGISTER_BEGIN, 
    };
  },

  registerSuccess: () => {
    return {
      type: actions.REGISTER_SUCCESS,
    };
  },

  registerErr: (err) => {
    return {
      type: actions.REGISTER_ERR,
      err,
    };
  },

  loginBegin: () => {
    return {
      type: actions.LOGIN_BEGIN, 
    };
  },

  loginSuccess: (data) => {
    return {
      type: actions.LOGIN_SUCCESS,
      data,
    };
  },

  loginErr: (err) => {
    return {
      type: actions.LOGIN_ERR,
      err,
    };
  },

  logoutBegin: () => {
    return {
      type: actions.LOGOUT_BEGIN,
    };
  },

  logoutSuccess: (data) => {
    return {
      type: actions.LOGOUT_SUCCESS,
      data,
    };
  },

  logoutErr: (err) => {
    return {
      type: actions.LOGOUT_ERR,
      err,
    };
  },

  loggedCheckBegin: () => {
    return {
      type: actions.LOGGED_CHECK_BEGIN,
    };
  },

  loggedCheckSuccess: (data) => {
    return {
      type: actions.LOGGED_CHECK_SUCCESS,
      data,
    };
  },

  loggedCheckErr: (err) => {
    return {
      type: actions.LOGGED_CHECK_ERR,
      err,
    };
  },
};

export default actions;
